import { StyledLoadingComponent } from "../../styled/LoadingComponent";

export default function LoadingComponent() {

  return (
    <StyledLoadingComponent.Root>
      <StyledLoadingComponent.CircularProgress />
      <StyledLoadingComponent.Title variant="h6">
        Cargando...
      </StyledLoadingComponent.Title>
    </StyledLoadingComponent.Root>
  );
}
